import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { startThemeSync } from "./theme";
import "./index.css";

// Resolve the theme BEFORE the first render so the pane doesn't paint light and
// then snap to dark. Started here rather than in an effect for that reason; it
// keeps following Outlook for the life of the pane.
startThemeSync();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
